export const hashCardMask = (cardMask?: string, prefix = '****') => {
  if (!cardMask) return '';

  const lastFourDigit = cardMask.slice(-4);
  return prefix + lastFourDigit;
};
